import {Nullable} from '../../app/TypeHelpers'

export interface OptionSettingForNewFacility {
    clientLocalId: string
    optionId: Nullable<number>
    name: string
    sortOrder: number
    charge: number
    chargeUnitTime: Nullable<number>
    chargeUnit: string
    volumeMin: number
    volumeMax: number
    unitName: string
    paymentMethod: string
    appointRequired: string
}

export interface ReservationSettingsForNewFacility {
    residentReserve: string
    lotteryAvailability: string
    lotteryPriority: Nullable<number>
    reserveReceptionStartMonth: Nullable<number>
    reserveReceptionStartDate: Nullable<number>
    reserveReceptionLimitDate: Nullable<number>
    reserveReceptionLimitTime: Nullable<string>
    cancelAvailability: string
    cancelReceptionLimitDate: Nullable<number>
    cancelReceptionLimitTime: Nullable<string>
}

export interface ServerImageInformation {
    fileNumber: Nullable<number>
    name: Nullable<string>
    base64data: Nullable<string>
    md5: Nullable<string>
}

export default class NewFacilityCommon {
    sortOrder: number
    categoryId: Nullable<string>
    // noinspection JSMismatchedCollectionQueryUpdate
    equipmentIds: number[]
    facilityName: string
    accessControlManager: Nullable<string>
    cardKeyFacilityNumber: Nullable<string>
    gateNumbers: Nullable<string[]>
    images: ServerImageInformation[]
    facilityIntroductory: string
    // noinspection JSMismatchedCollectionQueryUpdate
    optionSettings: OptionSettingForNewFacility[]
    reservationSetting: ReservationSettingsForNewFacility
    releaseSetting: string
    releaseStartDate: Nullable<string>
    releaseStartTime: Nullable<string>
    reserveBeforeCleaningTime: number
    reserveAfterCleaningTime: number

    constructor(
        sortOrder: number,
        categoryId: string | null,
        equipmentIds: number[],
        facilityName: string,
        accessControlManager: string | null,
        cardKeyFacilityNumber: string | null,
        gateNumbers: string[] | null,
        images: ServerImageInformation[],
        facilityIntroductory: string,
        optionSettings: OptionSettingForNewFacility[],
        reservationSetting: ReservationSettingsForNewFacility,
        releaseSetting: string,
        releaseStartDate: Nullable<string>,
        releaseStartTime: Nullable<string>,
        reserveBeforeCleaningTime: number,
        reserveAfterCleaningTime: number,
    ) {
        this.sortOrder = sortOrder
        this.categoryId = categoryId
        this.equipmentIds = equipmentIds
        this.facilityName = facilityName
        this.accessControlManager = accessControlManager
        this.cardKeyFacilityNumber = cardKeyFacilityNumber
        this.gateNumbers = gateNumbers
        this.images = images
        this.facilityIntroductory = facilityIntroductory
        this.optionSettings = optionSettings
        this.reservationSetting = reservationSetting
        this.releaseSetting = releaseSetting
        this.releaseStartDate = releaseStartDate
        this.releaseStartTime = releaseStartTime
        this.reserveBeforeCleaningTime = reserveBeforeCleaningTime
        this.reserveAfterCleaningTime = reserveAfterCleaningTime
    }
}
